import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FormTemplate } from "../types/forms";
import { getFormByUuid } from "../services/consultationform";
import UserPreview from "./forms/[id]/builder/UserPreview";

import { FormSection } from "../types/forms";

const mapSectionType = (section: FormSection): FormSection => {
  if (section.type) return section;

  const templateIdMap: Record<number, FormSection["type"]> = {
    1: "contact",
    2: "medical",
    3: "marketing",
    4: "question",
    6: "text",
    7: "policy",
    8: "disclaimer",
    9: "heading",
  };

  return {
    ...section,
    type: section.form_template_id ? templateIdMap[section.form_template_id] || null : null
  };
};

export default function PublicFormPage() {
  const { templateId } = useParams<{ templateId: string }>();
  const [template, setTemplate] = useState<FormTemplate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!templateId) return;

    const fetchTemplate = async () => {
      try {
        setLoading(true);
        const res = await getFormByUuid(templateId);
        if (res?.form) {
          const mappedForm = {
            ...res.form,
            sections: (res.form.sections || [])
              .map(mapSectionType)
              .sort((a: FormSection, b: FormSection) => (a.order || 0) - (b.order || 0))
          };
          setTemplate(mappedForm);
        } else {
          setError("Template not found");
        }
      } catch (err: any) {
        setError(err.message || "Failed to load template");
      } finally {
        setLoading(false);
      }
    };

    fetchTemplate();
  }, [templateId]);

  if (!templateId) {
    return (
      <div className="p-8 text-center text-red-500">
        Template ID is missing in the URL.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Loading public form...
      </div>
    );
  }

  if (error || !template) {
    return (
      <div className="p-8 text-center text-red-500">
        {error || "Failed to load template."}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-12">
      <UserPreview template={template} />
    </div>
  );
}
